

























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import MixinUserLogo from "./MixinUserLogo.vue";
import { Colors } from "@/types";

@Component({
  components: {
    MixinUserLogo
  }
})
class SnapshotItem extends Vue {
  @Getter("wallet/mixin/users/getUserById") getUserById;

  @Action("wallet/mixin/users/loadUser") loadUser;

  @Prop() snapshot;

  @Prop() asset;

  @Prop() last;

  validType = ["transfer", "deposit", "withdrawal", "fee", "rebate", "raw"];

  get user() {
    return this.getUserById(this.snapshot.opponent_id);
  }

  get amountText() {
    const amount = this.snapshot.amount;
    const value = Number(amount);
    return value > 0 ? `+${amount}` : amount;
  }

  get symbol() {
    return (this.asset && this.asset.symbol) || "-";
  }

  get type() {
    if (!this.snapshot) {
      return "-";
    }
    const type = this.snapshot.type;
    const valid = this.validType.includes(type);
    return valid
      ? this.$t(`wallet.snapshot.type.${type}`)
      : this.$t("wallet.snapshot.type.INVALID");
  }

  get amountColor() {
    const value = Number(this.snapshot.amount);
    return value > 0 ? Colors.GREEN : Colors.RED;
  }

  get hasReceiver() {
    return this.snapshot.receiver;
  }

  mounted() {
    this.loadUser(this.snapshot.opponent_id);
  }

  handleSnapshotClick() {
    this.$helper.toFusionPath(this, "wallet", {
      name: "transaction-id",
      params: { id: this.snapshot.snapshot_id },
      query: { data: encodeURIComponent(JSON.stringify(this.snapshot)) }
    });
  }
}
export default SnapshotItem;
